import { REQUEST_STATES } from '@/api/resources/entityState/request-state'
import { GridUtils } from '@/shared/util/grid-utils'

const createStatusFilterModel =
    status => ({
        status: GridUtils.getSetFilterModel([status])
    })

const getFullTranslationKey = key => `component.studyRequest.sideBar.${key}`

export default {
    sideBarName: 'RegistryExpandedSideBar',
    expanded: [
        {
            id: 'myRequests',
            label: getFullTranslationKey('requests'),
            icon: ['fal', 'file-alt'],
            hasChildren: true,
            children: [
                {
                    id: 'registryStates',
                    label: 'global.statusP',
                    hasChildren: true,
                    icon: ['fal', 'tags'],
                    children: [
                        {
                            id: 'registryRequested',
                            label: getFullTranslationKey('requested'),
                            filterModel: createStatusFilterModel(REQUEST_STATES.REQUESTED.code)
                        },
                        {
                            id: 'registryRegistered',
                            label: getFullTranslationKey('registered'),
                            filterModel: createStatusFilterModel(REQUEST_STATES.REGISTERED.code)
                        },
                        {
                            id: 'registryRequestsLocked',
                            label: getFullTranslationKey('blocked'),
                            filterModel: createStatusFilterModel(REQUEST_STATES.LOCKED.code)
                        },
                        {
                            id: 'registryReturned',
                            label: getFullTranslationKey('returned'),
                            filterModel: createStatusFilterModel(REQUEST_STATES.RETURNED.code)
                        },
                        {
                            id: 'registryCanceled',
                            label: getFullTranslationKey('canceled'),
                            filterModel: createStatusFilterModel(REQUEST_STATES.CANCELED.code)
                        }
                    ]
                },
                {
                    id: 'registryDates',
                    label: getFullTranslationKey('createdRequest'),
                    hasChildren: true,
                    icon: ['fal', 'calendar-alt'],
                    children: [
                        {
                            id: 'registryToday',
                            label: getFullTranslationKey('today'),
                            filterModel: {
                                reqRequestDate: GridUtils.getTodayDateFilterModel()
                            }
                        },
                        {
                            id: 'registryThisWeek',
                            label: getFullTranslationKey('thisWeek'),
                            filterModel: {
                                reqRequestDate: GridUtils.getThisWeekDateFilterModel()
                            }
                        },
                        {
                            id: 'registryThisMonth',
                            label: getFullTranslationKey('thisMonth'),
                            filterModel: {
                                reqRequestDate: GridUtils.getThisMonthDateFilterModel()
                            }
                        }
                    ]
                }
            ]
        }
    ],
    module: {
        icon: ['fal', 'envelope-open-text'],
        name: 'global.requestBox',
        subModule: 'global.register'
    }
}
